import React from 'react';
import ClubRegistrationFirstStep from './ClubRegistrationFirstStep';
import ClubRegistrationSecondStep from './ClubRegistrationSecondStep';
import ClubRegistrationModel from './ClubRegistrationModel';
import ClubRegistrationThirdStep from './ClubRegistrationThirdStep';
import ClubRegistrationFourthStep from './ClubRegistrationFourthStep';
import { Alert } from 'react-bootstrap';
import ClubRegistrationBreadcrumbComponent from './ClubRegistrationBreadcrumbComponent';
import Axios from 'axios';
import Loader from '../Loader';

class RegistrationFormDialog extends React.Component {
    constructor() {
        super();
        this.state = {
            currentStep: 1,
            showAlert: false,
            showUserExistsAlert: false,
            userExistsAlertMsg: '',
            teams: []
        }
        this.clubRegistrationModel = new ClubRegistrationModel();
        this.onNextBtnClick = this.onNextBtnClick.bind(this);
        this.onPreviousBtnClick = this.onPreviousBtnClick.bind(this);
        this.onRegisterBtnClick = this.onRegisterBtnClick.bind(this);
        this.showAlert = this.showAlert.bind(this);
        this.showUserExistsAlert = this.showUserExistsAlert.bind(this);

        this.setNotValidFieldsClass = this.setNotValidFieldsClass.bind(this);
        this.clearNotValidFieldsClass = this.clearNotValidFieldsClass.bind(this);
        this.setRadiofieldChecked = this.setRadiofieldChecked.bind(this);
        this.saveRegistrationModel = this.saveRegistrationModel.bind(this);
        this.getTeamsByClub = this.getTeamsByClub.bind(this);
        this.showCustomAlert = this.showCustomAlert.bind(this);
        this.firstStageFieldNamesArray = ['club', 'adminStreetName', 'adminHouseNumber', 'adminPostalCode', 'adminCityName', 'adminCountry', 'adminIsMainStadium', 'mainStadiumStreetName', 'mainStadiumHouseNumber', 'mainStadiumPostalCode', 'mainStadiumCityName', 'mainStadiumCountry', 'secondStadium', 'secondStadiumStreetName', 'secondStadiumHouseNumber', 'secondStadiumPostalCode', 'secondStadiumCityName', 'secondStadiumCountry']
        this.secondStageFieldNamesArray = ['adminUserCode', 'adminEmail', 'adminPhoneNumber', 'adminName', 'adminFirstName', 'adminLanguage'];
        this.thirdStageFieldNamesArray = ['clubCategoryCode', 'clubCommitmentCode', 'monoMulti', 'monoTeamId', 'numberOfTeams', 'team1Id', 'team2Id', 'team3Id', 'team4Id', 'team5Id', 'team6Id', 'team7Id', 'team8Id', 'team9Id', 'team10Id', 'team11Id', 'team12Id', 'team13Id', 'team14Id', 'team15Id', 'team16Id', 'team17Id', 'team18Id', 'team19Id', 'team20Id', 'team21Id', 'team22Id', 'team23Id', 'team24Id', 'team25Id', 'team26Id', 'team27Id', 'team28Id', 'team29Id', 'team30Id', 'team31Id', 'team32Id', 'team33Id', 'team34Id', 'team35Id', 'team36Id', 'team37Id', 'team38Id', 'team39Id', 'team40Id']
        this.fourthStageFieldNamesArray = ['sportSeasonFreeNarrative', 'sportSeasonFromDate', 'sportSeasonToDate', 'firstMonthInYear']
    }

    onNextBtnClick() {
        let canGoNext = false,
            currentForm = '',
            currentFieldsArray = [];
        if (this.state.currentStep === 1) {
            currentForm = 'firstStageForm';
            currentFieldsArray = this.firstStageFieldNamesArray;
            canGoNext = this.clubRegistrationFirstStep.onSubmit(this.clubRegistrationModel);
        } else if (this.state.currentStep === 2) {
            currentForm = 'secondStageForm';
            currentFieldsArray = this.secondStageFieldNamesArray;
            canGoNext = this.clubRegistrationSecondStep.onSubmit(this.clubRegistrationModel)
        } else if (this.state.currentStep === 3) {
            currentForm = 'thirdStageForm';
            currentFieldsArray = this.thirdStageFieldNamesArray;
            canGoNext = this.clubRegistrationThirdStep.onSubmit(this.clubRegistrationModel)
        } else if (this.state.currentStep === 4) {
            currentForm = 'fourthStageForm';
            currentFieldsArray = this.fourthStageFieldNamesArray;
            canGoNext = this.clubRegistrationFourthStep.onSubmit(this.clubRegistrationModel)
        }
        if (canGoNext && this.state.currentStep < 4) {
            this.setState({
                currentStep: this.state.currentStep + 1
            }, function () {
                let breadcrumbs = document.getElementsByClassName('registrationBreadcrumbItem');
                for (let i = 0; i < this.state.currentStep - 1; i++) {
                    breadcrumbs[i].classList.add('done')
                }
            })

        }
        if (canGoNext === false) {
            this.setNotValidFieldsClass(currentForm, currentFieldsArray)
            this.showAlert();
        }
    }

    saveRegistrationModel() {
        Axios({
            method: 'POST',
            url: 'config/getConfig',
            params: {
                name: 'ResourceServerBaseUrl'
            }
        }).then(response => {
            let url = response.data.value + '/public/registerClub/insert.do'
            Axios({
                method: 'POST',
                url: url,
                data: this.clubRegistrationModel
            }).then(response => {
                if (response.status && response.status === 200) {
                    this.props.closeModal();
                    this.props.showRegistrationSuccessInfo()
                }
            }).catch(error => {
                this.props.showRegistrationFailureInfo(error)
            })
        }).catch(error => {
            console.warn(error)
        })

    }
    onPreviousBtnClick() {
        if (this.state.currentStep === 1) {
            this.clubRegistrationFirstStep.setDataOnModel(this.clubRegistrationModel);
        } else if (this.state.currentStep === 2) {
            this.clubRegistrationSecondStep.setDataOnModel(this.clubRegistrationModel)
        } else if (this.state.currentStep === 3) {
            this.clubRegistrationThirdStep.setDataOnModel(this.clubRegistrationModel)
        } else if (this.state.currentStep === 4) {
            this.clubRegistrationFourthStep.setDataOnModel(this.clubRegistrationModel)
        }
        this.setState({
            currentStep: this.state.currentStep - 1
        })
    }
    onRegisterBtnClick() {
        let canGoNext = false;
        canGoNext = this.clubRegistrationFourthStep.onSubmit(this.clubRegistrationModel);
        if (canGoNext === false) {
            this.showAlert();
        } else {
            this.saveRegistrationModel()
        }
    }


    showAlert() {
        const me = this;
        this.setState({
            showAlert: true
        }, function () {
            setTimeout(function () {
                me.setState({
                    showAlert: false
                });
            }, 5000);

        })
    }

    showUserExistsAlert(userExistsAlertMsg) {
        const me = this;
        this.setState({
            showUserExistsAlert: true,
            userExistsAlertMsg: userExistsAlertMsg
        }, function () {
            setTimeout(function () {
                me.setState({
                    showUserExistsAlert: false,
                    userExistsAlertMsg: ''
                });
            }, 5000);

        })
    }
    setNotValidFieldsClass(currentForm, currentFieldsArray) {
        let form = document.forms[currentForm]
        currentFieldsArray.forEach(field => {
            if (form[field] && (form[field].type === 'text' || form[field].type === 'select-one' || form[field].type === 'email')) {
                if (form[field].value === '' || form[field].value == 0 || form[field].value == null) {
                    form[field].classList.add('requiredField')

                }
            } else if (form[field] && (form[field].type === undefined && form[field].value === '')) {
                try {
                    let fieldset = document.getElementsByClassName(`${field}RadioField`);
                    if (fieldset && fieldset.length > 0) {
                        fieldset.forEach(set => {
                            if (set.classList.contains('requiredField')) {
                                set.classList.remove('requiredField')
                            }
                        });
                    }
                } catch (error) {
                    console.log(error)
                }

            }
        });
        setTimeout(() => this.clearNotValidFieldsClass(currentForm, currentFieldsArray), 7000)
    }

    clearNotValidFieldsClass(currentForm, currentFieldsArray) {
        let form = document.forms[currentForm];
        if (form) {
            currentFieldsArray.forEach(field => {
                if (form[field]) {
                if (form[field].type === 'text' || form[field].type === 'select-one' || form[field].type === 'email' || form[field].type === 'date') {

                    if (form[field].classList.contains('requiredField')) {
                        form[field].classList.remove('requiredField')
                    } else {

                    }
                } else if (form[field].type === undefined && form[field].value === '') {
                    try {
                        let fieldset = document.getElementsByClassName(`${field}RadioField`);
                        if (fieldset && fieldset.length > 0) {
                            fieldset.forEach(set => {
                                if (set.classList.contains('requiredField')) {
                                    set.classList.remove('requiredField')
                                }
                            });
                        }
                    } catch (error) {
                        console.log(error)
                    }

                }
                }
            });
        }
    }

    setRadiofieldChecked(form, field, value) {
        try {
            let radioFields = document.forms[form][field]
            radioFields.forEach(radioField => {
                if (radioField.value == value.toString()) {
                    radioField.checked = true
                }
            });
        } catch (error) {
            console.log(error)
        }
    }
    getTeamsByClub(clubId) {
        const me = this;
        if (clubId > 0) {
            let baseUrl = localStorage.getItem('ResourceServerBaseUrl')
            Axios({
                method: 'POST',
                url: baseUrl + '/public/team/listByClub.do',
                params: {
                    clubId: clubId
                }
            }).then(response => {
                if (response.status === 200) {
                    me.setState({
                        teams: response.data
                    })
                } else {
                    me.setState({
                        teams: []
                    })
                    me.showCustomAlert(
                        true,
                        'danger',
                        me.props.composingLabel('', 'Data fetch failed', true),
                        me.props.composingLabel('', 'Something happened while getting teams for selected club, please contact the administration')
                    )
                }
            }).catch(error => {
                console.log(error)
                me.showCustomAlert(
                    true,
                    'danger',
                    me.props.composingLabel('', 'Data fetch failed', true),
                    me.props.composingLabel('', 'Something happened while getting teams for selected club, please contact the administration')
                )
                me.setState({
                    teams: [],

                })
            })
        } else {
            me.setState({
                teams: []
            })

        }
    }

    showCustomAlert(showCustomAlert, customAlertType, customAlertTitle, customAlertMsg) {
        const me = this;
        this.setState({
            showCustomAlert,
            customAlertType,
            customAlertTitle,
            customAlertMsg
        }, function () {
            setTimeout(function () {
                me.setState({
                    showCustomAlert: false,
                    customAlertType: 'success',
                    customAlertTitle: '',
                    customAlertMsg: ''
                });
            }, 5000);

        })
    }
    render() {
        let { composingLabel } = this.props;
        return (
            <div className='registrationFormWrapper'>
                <div className='registrationFormHeader'>
                    <button className='registrationFormHeaderClosebtn' onClick={() => this.props.closeModal()}>
                        <img className='registrationFormHeaderCloseImg' src={require('../../images/closeIcon.png')} />
                    </button>
                </div>
                <ClubRegistrationBreadcrumbComponent currentStep={this.state.currentStep} composingLabel={composingLabel} />

                <div className='registrationFormMainPanel'>
                    {this.state.currentStep === 1 && <ClubRegistrationFirstStep
                        clubRegistrationModel={this.clubRegistrationModel}
                        countries={this.props.countries}
                        clubs={this.props.clubs}
                        getTeamsByClub={this.getTeamsByClub}
                        composingLabel={composingLabel}
                        setRadiofieldChecked={this.setRadiofieldChecked}
                        onRef={clubRegistrationFirstStep => this.clubRegistrationFirstStep = clubRegistrationFirstStep} />}
                    {this.state.currentStep === 2 && <ClubRegistrationSecondStep
                        clubRegistrationModel={this.clubRegistrationModel}
                        languages={this.props.languages}
                        composingLabel={composingLabel}
                        checkUserExists={this.props.checkUserExists}
                        showUserExistsAlert={this.showUserExistsAlert}
                        onRef={clubRegistrationSecondStep => this.clubRegistrationSecondStep = clubRegistrationSecondStep} />}
                    {this.state.currentStep === 3 && <ClubRegistrationThirdStep
                        clubRegistrationModel={this.clubRegistrationModel}
                        setRadiofieldChecked={this.setRadiofieldChecked}
                        composingLabel={composingLabel}
                        teams={this.state.teams}
                        onRef={clubRegistrationThirdStep => this.clubRegistrationThirdStep = clubRegistrationThirdStep} />}
                    {this.state.currentStep === 4 && <ClubRegistrationFourthStep
                        clubRegistrationModel={this.clubRegistrationModel}
                        setRadiofieldChecked={this.setRadiofieldChecked}
                        clubSeasons={this.props.clubSeasons}
                        composingLabel={composingLabel}
                        onRef={clubRegistrationFourthStep => this.clubRegistrationFourthStep = clubRegistrationFourthStep} />}
                    {this.state.showAlert && <Alert bsStyle="danger" className='registrationFormDialogAlert' >
                        <h4>{composingLabel('sportOauthLabel.formValidation', 'Form validation')}</h4>
                        <p>{composingLabel('sportOauthLabel.formValidationFailed', 'All fields are required, please fill all the fields correctly.')} </p>
                    </Alert>}
                    {this.state.showUserExistsAlert && <Alert bsStyle="danger" className='registrationFormDialogAlert' >
                        <h4>{composingLabel('sportOauthLabel.formValidation', 'Form validation')}</h4>
                        <p>{this.state.userExistsAlertMsg} </p>
                    </Alert>}
                    {this.state.showCustomAlert && <Alert bsStyle={this.state.customAlertType} className='registrationFormDialogAlert' >
                        <h4>{this.state.customAlertTitle}</h4>
                        <p>{this.state.customAlertMsg} </p>
                    </Alert>}
                </div>

                <div className='registrationFormFooter'>
                    {this.state.currentStep === 4 && <button
                        onClick={() => this.onRegisterBtnClick()}
                        className='registrationFooterBtn'>
                        {composingLabel('sportOauthLabel.register', 'Register')}</button>}
                    {this.state.currentStep > 1 && <button
                        onClick={() => this.onPreviousBtnClick()}
                        className='registrationFooterBtn'>
                        <img
                            className='registrationFooterBtnImg'
                            src={require('../../images/previousIcon.png')} />
                        {composingLabel('sportOauthLabel.previous', 'Previous')}</button>}
                    {this.state.currentStep < 4 && <button
                        className='registrationFooterBtn'
                        onClick={() => {
                            this.onNextBtnClick()
                        }}>
                        {composingLabel('sportOauthLabel.next', 'Next')}
                        <img
                            className='registrationFooterBtnImg'
                            src={require('../../images/nextIcon.png')} /></button>}
                </div>
                <div id='clubRegisterLoaderWrapper' className='clubRegisterLoaderWrapper clubRegisterLoaderWrapperHidden'>
                    <Loader loading={true} />
                </div>
            </div>

        )
    }
}

export default RegistrationFormDialog;


// WEBPACK FOOTER //
// ./src/main/resources/js/components/RegistrationFormComponents/RegistrationFormDialog.js